import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { selectCountry, selectPayment, selectDelivery, selectDispatchPoint } from '@store/order/selectors';
import { useLazyGetPaymentTypesQuery } from '@api/baseApi';
import { CountryEnum } from '@api/types/CountryEnum';



const PaymentShipping = (): JSX.Element => {

	const country = useSelector(selectCountry);
	const payment = useSelector(selectPayment);
	const delivery = useSelector(selectDelivery);
	const dispatchPoint = useSelector(selectDispatchPoint);

	const [ getPayments, { data, isLoading, isFetching, isError } ] = useLazyGetPaymentTypesQuery();

	useEffect(() => {
		if (country) {
			getPayments({ country }, true);
		}
	}, [ country ]);

	const selectedPayment = data && data.length > 0 && payment ? data.find(x => x.id === payment.id) : null;

	if (isError || isFetching || isLoading || !selectedPayment || !delivery) return (
		<div className='order-summary-element'>
			<h2>Vzor</h2>
			<div className='summary-property'></div>
		</div>
	)

	return (
		<>
			<div className='order-summary-element'>

				<h2>Platba</h2>

				<div className='summary-property'>
					<p>{`${selectedPayment.description} (${
						selectedPayment.price === 0
							? 'ZDARMA'
							: country === CountryEnum.sk
							? `${selectedPayment.price} \u20AC`
							: `${selectedPayment.price} Kč`
					})`}</p>
				</div>

			</div>


			<div className='order-summary-element'>

				<h2>Doprava</h2>

				<div className='summary-property'>
					<p>{`${delivery.description} (${
						delivery.price === 0
							? 'ZDARMA'
							: country === CountryEnum.sk
							? `${delivery.price} \u20AC`
							: `${delivery.price} Kč`
					})`}</p>
				</div>

			</div>

			{dispatchPoint !== null && dispatchPoint !== undefined &&
				<div className='order-summary-element'>

					<h2>Výdejní místo</h2>

					<div className='summary-property'>
						<p>{dispatchPoint.name}</p>
					</div>

				</div>
			}

		</>
	);
};

export default PaymentShipping;